module.exports = __webpack_public_path__ + "img/hotels-canada-4.9ec09b80.png";